import { Checkbox } from "@/components/elements/Checkbox";
import { useFormField } from "@/components/elements/FormField";
import { Stack, SxProps, Theme } from "@mui/material";
import { ChangeEvent, FC, Key, useEffect, useState } from "react";

export type TCheckboxOption = {
  value: Key;
  label: string;
  subLabel?: string;
};

type TCheckboxGroupProps = {
  options: TCheckboxOption[];
  nonControl?: boolean;
  value?: Key[];
  enableOrderNumber?: boolean;
  disabled?: boolean;
  onChange?: (value: Key[]) => void;
  sx?: SxProps<Theme>;
};

export const CheckboxGroup: FC<TCheckboxGroupProps> = ({
  options,
  nonControl = false,
  value,
  enableOrderNumber = false,
  disabled = false,
  onChange,
  sx,
}) => {
  const [checkedValues, setCheckedValues] = useState<Key[]>([]);
  const { field } = useFormField(nonControl);

  useEffect(() => {
    setCheckedValues(field?.value ?? value ?? []);
  }, [field?.value, value]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;
    let newValues = [...checkedValues];
    if (checked) {
      newValues = [...newValues, value];
    } else {
      newValues = newValues.filter((v) => v !== value);
    }
    setCheckedValues(newValues);
    onChange?.(newValues);
    field?.onChange(newValues);
    field?.onBlur();
  };

  return (
    <Stack gap={1} sx={sx}>
      {options.map(({ label, subLabel, value }, index) => {
        return (
          <Checkbox
            key={index}
            label={label}
            prefixLabel={enableOrderNumber ? `${index + 1}.` : null}
            subLabel={subLabel}
            value={value}
            checked={checkedValues.includes(value.toString())}
            disabled={disabled}
            onChange={handleChange}
            nonControl
          />
        );
      })}
    </Stack>
  );
};
